import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { LockLocked, People } from '@factorialco/f0-react/icons/app'
import { DocumentsPageDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import NotFound from 'modules/core/components/NotFound'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import FilesCategoryList from 'modules/bookkeepers/components/PayrollCycle/FilesCategoryList'

interface Props {
  payrollRunId: number
  hasProfessionals: boolean
}

const Documents = ({ payrollRunId, hasProfessionals }: Props) => {
  const {
    company: { id: companyId },
  } = useCurrentSession()

  const lastFileCreatedAt = undefined

  const { loading, data } = useQuery(DocumentsPageDocument, {
    variables: {
      companyId,
      payrollRunId,
    },
  })

  const sharedCategories =
    data?.compensations.fileCategoriesConnection.nodes.filter(
      (category) => category.categoryType !== 'exported'
    ) ?? []
  const exportedCategory = data?.compensations.fileCategoriesConnection.nodes.find(
    (category) => category.categoryType === 'exported'
  )

  if (loading) return <Loading />

  if (!data?.compensations?._policies?.compensationActivityManage?.can) {
    return <NotFound />
  }

  const emptyStateSharedCategories = {
    'no-data': {
      title: i18n.t(
        'compensations.PayrollRunCompensationsList.activity_sidepanel.documents.empty_state.title'
      ),
      description: i18n.t(
        'compensations.PayrollRunCompensationsList.activity_sidepanel.documents.empty_state.description_documents'
      ),
    },
  }

  const emptyStateExportedCategory = {
    'no-data': {
      title: i18n.t(
        'compensations.PayrollRunCompensationsList.activity_sidepanel.documents.empty_state.title'
      ),
      description: i18n.t(
        'compensations.PayrollRunCompensationsList.activity_sidepanel.documents.empty_state.description_documents'
      ),
    },
  }

  return (
    <>
      {hasProfessionals && (
        <Box padding="s24" gap="s8">
          <Box flexDirection="row" padding="s0">
            <F0Icon icon={People} size="lg" color="default" />
            <Text.Normal color="grey1000" weight="semibold">
              {i18n.t(
                'compensations.PayrollRunCompensationsList.activity_sidepanel.documents.documents.title'
              )}
            </Text.Normal>
          </Box>
          <Box alignItems="center" paddingX="s24" paddingY="s0">
            {sharedCategories && sharedCategories.length > 0 && (
              <FilesCategoryList
                companyId={companyId}
                payrollRunId={payrollRunId}
                categories={sharedCategories}
                emptyState={emptyStateSharedCategories}
                refetchTrigger={lastFileCreatedAt}
                sidebarView
              />
            )}
          </Box>
        </Box>
      )}
      <Box padding="s24" gap="s8">
        <Box flexDirection="row" padding="s0">
          <F0Icon icon={LockLocked} size="lg" color="default" />
          <Text.Normal color="grey1000" weight="semibold">
            {i18n.t(
              'compensations.PayrollRunCompensationsList.activity_sidepanel.documents.exports.title'
            )}
          </Text.Normal>
        </Box>
        <Box alignItems="center" paddingX="s24">
          {exportedCategory && (
            <FilesCategoryList
              companyId={companyId}
              payrollRunId={payrollRunId}
              categories={[exportedCategory]}
              emptyState={emptyStateExportedCategory}
              refetchTrigger={lastFileCreatedAt}
              sidebarView
            />
          )}
        </Box>
      </Box>
    </>
  )
}

export default Documents
